import React from "react";
import { CV } from "../components/cv";
import SebastianAImg from "@/assets/images/sebastian-a.png";

export default function CVSebastianAndersson() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Sebastian Andersson";
  }, []);

  return (
    <CV
      name="Sebastian Andersson"
      photo={SebastianAImg}
      title="Scrum Master · Agile Coach · Product & Delivery Leadership"
      subtitle="Agile coaching at IKEA scale — embedded with 10+ engineering teams, 250+ people trained, agile practices standardised across 1,000+ engineers. Former full-stack developer."
      summary="Agile Coach and Scrum Master with 4+ years at IKEA, embedded with 10+ engineering teams and training 250+ developers, Product Owners and Scrum Masters in agile ways of working. Set up ways of working and coached leadership and product teams within IKEA's platform engineering domain, and led a company-wide effort to standardise agile practices across 1,000+ engineers. Former full-stack developer, so I understand the work behind the backlog and quickly earn trust with developers."
      skills={{
        "Leadership & Delivery": [
          "Agile coaching",
          "Scrum facilitation",
          "Agile training & workshop delivery",
          "Platform engineering enablement",
          "Backlog & roadmap prioritisation",
          "Stakeholder management",
          "Cross-team facilitation",
          "Organisational change management",
        ],
        "Agile Frameworks": ["Scrum", "Kanban", "SAFe", "OKRs"],
        "Languages & Frameworks": [
          "TypeScript",
          "JavaScript",
          "React",
          "Node / Express",
        ],
        "Cloud & Tooling": [
          "GCP Suite",
          "Contentful (Headless CMS)",
          "Git",
          "GitHub",
          "Jira",
          "Confluence",
          "Miro",
        ],
        Languages: ["Swedish (native)", "English (professional)"],
      }}
      experience={[
        {
          role: "Agile Team Coach",
          company: "IKEA, Malmö",
          period: "Aug 2022 – Sep 2026",
          description:
            "Part of IKEA's agile coaching function, responsible for coaching teams across the organisation — including leadership and product teams in the platform engineering domain — in agile ways of working, and deployed to teams on request.",
          highlights: [
            "Set up ways of working for, and coached, leadership and product teams within IKEA's platform engineering domain, aligning delivery practices with the domain's technical roadmap and priorities.",
            "Embedded with 10+ engineering teams to introduce and improve Scrum and agile practices, running day-to-day ceremonies for both teams and their leads, and raising sprint completion rates to the point other teams used them as a benchmark.",
            "Designed and delivered on-demand agile training workshops for mixed groups of around 20 developers, Product Owners, Scrum Masters and other roles — 250+ people trained in total, including 15+ Product Owners.",
            "Facilitated sprint planning, daily stand-ups, retrospectives and demos, and coached developers and Product Owners in their roles.",
            "Helped plan and run agile events for larger multi-team groups.",
            "Acted as the main point of contact between engineering leadership, product owners and delivery teams, resolving priority conflicts before they reached the team and keeping goals aligned as organisational priorities shifted — cutting rework and mid-sprint context-switching.",
            "Led a company-wide effort to standardise how agile teams work, rolled out to 1,000+ engineers.",
          ],
        },
        {
          role: "Software Engineer",
          company: "IKEA, Malmö",
          period: "Aug 2019 – Aug 2022",
          description:
            "Full-stack developer in an engineering team building internal coworker tools on IKEA's content management system, working across React frontend, Express/TypeScript backend and GCP.",
          highlights: [
            "Built and led full-stack features for internal tools connected to IKEA's content management system, used daily by employees across IKEA.",
            "Designed a REST API to pull data out of the CMS and make it available to teams that previously had no access to it.",
            "Owned security for the team: set up automated code and GCP vulnerability scanning, built it into the team's daily workflow and acted as primary point of contact for security issues.",
            "Worked across the stack day to day, from UI work in React to backend and API design in Express, picking up whatever the team needed to ship.",
          ],
        },
      ]}
      education={[
        {
          degree: "Bachelor's degree in Computer Science",
          institution: "Malmö University, Malmö",
          year: "2016 – 2019",
        },
        {
          degree: "Practical Project Management (summer intensive)",
          institution: "Stockholm University, Stockholm",
          year: "2018",
        },
      ]}
      certifications={[
        { name: "Professional Scrum Master I", issuer: "Scrum.org" },
        { name: "Situational Leadership II", issuer: "Blanchard" },
        { name: "IKEA Leadership Fundamentals" },
      ]}
    />
  );
}
